import { z } from 'zod';
import { BaseErrorSchema } from 'libs/end-to-end/src/types/errors/base-error-schema';

export const OrganizationHasDatabasesError = BaseErrorSchema.extend({
  errorType: z.literal('OrganizationHasDatabasesError'),
  organizationId: z.string(),
  databaseIds: z.array(z.string()),
});

export type OrganizationHasDatabasesError = z.infer<
  typeof OrganizationHasDatabasesError
>;
